module.exports = __webpack_public_path__ + "static/media/ic_cancel_grey.97d56c4b.png";